export const createCancellablePromise = <TResponse = unknown>(
  callable: (abortController: AbortController) => TResponse,
) => {
  const abortController = new AbortController();

  return {
    abortController,
    cancel: () => { abortController.abort(); },
    promise: () => callable(abortController),
  };
};

export type CancellablePromise<T = unknown> = ReturnType<typeof createCancellablePromise<T>>;
